module.exports = __webpack_public_path__ + "post-listing-block-4-overlay-wide@2x-3IOzTp8.png";